import { getListaTriEduc } from "@/services/report";
import { mascaraCpf } from "@/utils/masks";
import ListaPlataforma, { ColunaLista } from "../ListasPlataformas/ListaPlataforma";

interface ListaTriEducItem {
  // "Avançada" ou "Regular" — normalizado pelo backend a partir do nome da turma.
  turma: string;
  nome: string;
  cpf: string;
  email: string;
}

const colunas: ColunaLista<ListaTriEducItem>[] = [
  { titulo: "TURMA", campo: "turma", width: 140 },
  { titulo: "NOME", campo: "nome", width: 280 },
  {
    titulo: "CPF",
    campo: "cpf",
    width: 160,
    formatar: (cpf: string) => (cpf ? mascaraCpf(cpf) : ""),
  },
  { titulo: "Email", campo: "email", width: 260 },
];

export default function ListaTriEduc() {
  return (
    <ListaPlataforma<ListaTriEducItem>
      titulo="Lista TriEduc"
      nomeArquivo="lista_trieduc"
      nomePlanilha="Lista TriEduc"
      buscar={getListaTriEduc}
      colunas={colunas}
    />
  );
}
